import { unescape } from 'html-escaper';

import { htmlTag } from './regexps';

export function getAttributeValue(tag: string, attrName: string) {
    // защита от кейсов типа поиска значения href в <a wtf="href" it="fails" href="abc">
    if (tag.split(attrName).length !== 2) {
        return undefined;
    }
    const splitted = tag.replace(/<|>|\/>/g, '').split('=');

    if (splitted.length < 2) {
        return undefined;
    }
    const prevElementIndex = splitted.findIndex((el: string) => el.includes(attrName));

    return splitted[prevElementIndex + 1].trim().split(' ')[0].replace(/('|")/g, '');
}

export function resolveDividers(text: string) {
    return unescape(text);
}

export function clearOtherTags(text: string) {
    return text.replace(htmlTag, '');
}

export function textMutator(mutators: Array<(text: string) => string>) {
    return function compose(text: string) {
        return mutators.reduce((acc, m) => m(acc), text);
    };
}
